<template>
    <dashboard v-if="user">
        <row>
            <panel size="col-24">
                <h3 slot="title">Information</h3>
                <template slot="buttons">
                    <app-button
                        v-if="$role.isMasterAdmin()"
                        size="small"
                        @click="handleLoginUser">Login As User</app-button>
                    <app-button type="danger" size="small" @click="handleRemoveUser">Remove</app-button>
                </template>

                <app-form
                    ref="infoForm"
                    :model="user"
                    :rules="rules"
                    @submit.native.prevent="submit">
                    <p class="required-fields">All fields marked with * are required</p>
                    <grid>
                        <grid-item width="4" mobile-width="6">
                            <app-form-item label="First Name" prop="first_name">
                                <app-input id="first_name" v-model="user.first_name"/>
                            </app-form-item>
                        </grid-item>
                        <grid-item width="4" mobile-width="6">
                            <app-form-item label="Last Name" prop="last_name">
                                <app-input id="last_name" v-model="user.last_name"/>
                            </app-form-item>
                        </grid-item>
                        <grid-item width="4" mobile-width="12">
                            <app-form-item label="Email" prop="email">
                                <app-input id="email" v-model="user.email"/>
                            </app-form-item>
                        </grid-item>
                  
                        <grid-item width="4" mobile-width="12">
                            <app-form-item label="Phone Number" prop="phone_number">
                                <app-input 
                                    id="phone_number" 
                                    v-model="user.phone_number"
                                    placeholder="(123) 456 7890" />
                            </app-form-item>
                        </grid-item>
                        <grid-item width="4" mobile-width="12">
                            <app-form-item v-if="id != me.id" label="Role" prop="role">
                                <app-select
                                    id="role"
                                    v-model="user.role_id"
                                    placeholder="Select">
                                    <app-option
                                        v-for="item in roles"
                                        :key="item.id"
                                        :label="item.display_name"
                                        :value="item.id"/>
                                </app-select>
                            </app-form-item>
                        </grid-item>
                    </grid>
                    <br>
                    <app-button
                        :loading="isSaving"
                        type="primary"
                        native-type="submit"
                        size="large">Save</app-button>
                </app-form>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import User from '@/store/models/User'

import TeamPicker from '../Team/TeamPicker'
import CoursePicker from '../Course/CoursePicker'
import StudentPicker from '../Student/StudentPicker'

export default {
    name: 'page-users-information',
    components: {
        TeamPicker,
        CoursePicker,
        StudentPicker
    },
    props: ['id'],
    data() {
        return {
            isSaving: false,
            loading: false,
            showTeamPicker: false,
            showCoursePicker: false,
            showStudentPicker: false,
            user: User.$cloneOrNew(this.id),
            rules: {
                first_name: [
                    {
                        required: true,
                        message: 'Please enter a first name',
                        trigger: 'blur'
                    }
                ],
                last_name: [
                    {
                        required: true,
                        message: 'Please enter a last name',
                        trigger: 'blur'
                    }
                ],
                email: [
                    {
                        required: true,
                        message: 'Please enter an email',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    computed: {
        ...mapState({
            roles: ({ params }) => params.roles,
            me: ({ me }) => me.current
        })
    },
    mounted() {
        this.getParams()
    },
    methods: {
        ...mapActions([
            'switchUser',
            'getParams'
        ]),
        submit() {
            this.isSaving = true
            this.$refs['infoForm'].validate(valid => {
                if (!valid) return

                this.user.$update()
                    .then(() => {
                        this.isSaving = false
                        this.$notify({
                            title: 'Success',
                            message: 'The user has been successfully saved!',
                            type: 'success',
                            offset: 75,
                            duration: 2000
                        })
                    })
                    .catch(() => {
                        this.isSaving = false
                    })
            })
            return false
        },
        handleLoginUser() {
            this.$confirm({
                title: 'Confirm',
                message:
                    'You are about to login as ' +
                    this.user.first_name +
                    ' ' +
                    this.user.last_name +
                    '. ' +
                    'If you wish to return to your current user, you will need to logout and log back in.'
            }).then(() => {
                this.switchUser(this.user.id)
            })
        },
        handleRemoveUser() {
            this.$confirm({
                title: 'Confirm',
                message: 'Are you sure you want to remove this user?'
            })
                .then(() => {
                    return this.user.$remove()
                })
                .then(() => {
                    this.$router.push({ name: 'users' })
                })
        }
    }
}
</script>

<style lang="stylus"></style>
